import React, { useState, useEffect } from "react";
import styles from "./CreateFollowUp.module.scss";
import { createFollowUp } from "../../apiServices";
import { decryptedAdminID } from "../../utility";

const CreateFollowUp = ({ entityId, stageId, candidateId,entityType = "INTERVIEW",  onSuccess, onCancel }) => {
  const adminID = decryptedAdminID();

  const getStageId = () => {
    if (entityType === "REGISTERED") {
      return 6; // Default stage for candidate registration
    }
    return stageId; // Use the passed stageId for INTERVIEW
  };

  const [formData, setFormData] = useState({
    // entity_type: "INTERVIEW",
    // entity_id: entityId,
     entity_type: entityType,  // Use the prop instead of hardcoded "INTERVIEW"
    entity_id: entityId || candidateId,  // For Register, use candidateId as entity_id
    // stage_id: stageId,
     stage_id: getStageId(),
    candidate_id: candidateId,
    title: "",
    description: "",
    followup_date: "",
    priority: "",
    followup_type: "GENERAL",
    created_by: adminID,
    admin_id: adminID,
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    title: "",
    followup_date: "",
    priority: "",
    description: "",
    general: ""
  });

  // Priority options
  const priorityOptions = [
    { value: "LOW", label: "Low" },
    { value: "MEDIUM", label: "Medium" },
    { value: "HIGH", label: "High" },
    { value: "CRITICAL", label: "Critical" },
  ];

  // Title options
  // const titleOptions = [
  //   { value: "Call Remainder", label: "Call Remainder" },
  //   { value: "Interview Follow Up", label: "Interview Follow Up" },
  //   { value: "Joining Follow Up", label: "Joining Follow Up" },
  // ];
    const getTitleOptions = () => {
    if (entityType === "REGISTERED") {
      // For candidate profile (DetailContainer)
      return [
        { value: "Call Remainder", label: "Call Remainder" },
        { value: "Document Remainder", label: "Document Remainder" },
        { value: "Tentative Date", label: "Tentative Date" },
      ];
    } else {
      // For interview pipeline (CandidateCard) - default
      return [
        { value: "Call Remainder", label: "Call Remainder" },
        { value: "Interview Follow Up", label: "Interview Follow Up" },
        { value: "Joining Follow Up", label: "Joining Follow Up" },
      ];
    }
  };
   const titleOptions = getTitleOptions();

  // Remove the useEffect that sets default values, or modify it to only set placeholder
  useEffect(() => {
    // Don't set default values - let them be empty for validation
    // This ensures validation works properly
  }, []);

  // Optional: If you want to show a default date but still validate if user doesn't change it
  // You can use a different approach - track if user has touched the field
  const [touched, setTouched] = useState({
    title: false,
    priority: false,
    followup_date: false,
    description: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Mark field as touched when user interacts
    setTouched((prev) => ({
      ...prev,
      [name]: true
    }));

    // Clear error for this specific field when user interacts
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // Also clear general error if it exists
    if (errors.general) {
      setErrors((prev) => ({
        ...prev,
        general: "",
      }));
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({
      ...prev,
      [name]: true
    }));

    // Validate on blur
    if (name === 'priority' && !formData.priority) {
      setErrors((prev) => ({
        ...prev,
        priority: "Please select priority"
      }));
    }

    if (name === 'followup_date' && !formData.followup_date) {
      setErrors((prev) => ({
        ...prev,
        followup_date: "Please select follow-up date and time"
      }));
    }

    if (name === 'title' && !formData.title) {
      setErrors((prev) => ({
        ...prev,
        title: "Please select a title"
      }));
    }
      if (name === 'description' && !formData.description) {
      setErrors((prev) => ({
        ...prev,
        description: "Please select description"
      }));
    }

  };

  const formatDateTimeForAPI = (date) => {
    if (!date) return null;
    // Add '00:00:00' as the time portion
    return date + ' 00:00:00';
  };

  const validateForm = () => {
    const newErrors = {
      title: "",
      followup_date: "",
      priority: "",
      description: "",
      general: ""
    };
    let isValid = true;

    // Validate title
    if (!formData.title || formData.title.trim() === "") {
      newErrors.title = "Please select a title";
      isValid = false;
    }

    // Validate followup date
   if (!formData.followup_date || formData.followup_date.trim() === "") {
      newErrors.followup_date = "Please select follow-up date";
      isValid = false;
    }
    // Validate priority
    if (!formData.priority || formData.priority.trim() === "") {
      newErrors.priority = "Please select priority";
      isValid = false;
    }
  if (!formData.description || formData.description.trim() === "") {
      newErrors.description = "Please select description";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched
    setTouched({
      title: true,
      priority: true,
      followup_date: true,
      description: true
    });

    if (!validateForm()) {
      // Scroll to the first error field
      const firstErrorField = document.querySelector(`.${styles.errorInput}`);
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    setLoading(true);

    const payload = {
      entity_type: formData.entity_type,
      entity_id: formData.entity_id,
      stage_id: formData.stage_id,
      candidate_id: formData.candidate_id,
      title: formData.title,
      description: formData.description,
       followup_date: formatDateTimeForAPI(formData.followup_date),
      priority: formData.priority,
      followup_type: formData.followup_type,
      created_by: formData.created_by,
      admin_id: formData.admin_id,
    };

    console.log("Sending payload:", payload);

    try {
      const result = await createFollowUp(payload);
      console.log("Follow-up created successfully:", result);

      if (onSuccess) {
        onSuccess(result);
      }
    } catch (err) {
      console.error("Error:", err);
      // Set a general error
      setErrors((prev) => ({
        ...prev,
        general: err.message || "Failed to create follow-up. Please try again."
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <div className={styles.header}>
          <div >
            <h5 className={styles.heading}>Create Follow-up</h5>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onCancel}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* General Error */}
        {errors.general && (
          <div className={styles.errorMessage}>
            {errors.general}
          </div>
        )}

        {/* Title Field */}
        <div className={styles.field}>
          <label>Title *</label>
          <select
            name="title"
            value={formData.title}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.title && touched.title ? styles.errorInput : ""}
          >
            <option value="">Select Title</option>
            {titleOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errors.title && touched.title && (
            <div className={styles.fieldError}>{errors.title}</div>
          )}
        </div>

        {/* Priority Field */}
        <div className={styles.field}>
          <label>Priority *</label>
          <select
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.priority && touched.priority ? styles.errorInput : ""}
          >
            <option value="">Select Priority</option>
            {priorityOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errors.priority && touched.priority && (
            <div className={styles.fieldError}>{errors.priority}</div>
          )}
        </div>

        {/* Follow-up Date Field */}
         <div className={styles.field}>
          <label>Follow-up Date *</label>
          <input
            type="date"
            name="followup_date"
            value={formData.followup_date}
            onChange={handleChange}
            onBlur={handleBlur}
            min={new Date().toISOString().split('T')[0]}  
            className={errors.followup_date && touched.followup_date ? styles.errorInput : ""}
          />
          {errors.followup_date && touched.followup_date && (
            <div className={styles.fieldError}>{errors.followup_date}</div>
          )}
        </div>

        {/* Description Field */}
        <div className={styles.field}>
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Enter details..."
            rows="4"
            className={errors.description && touched.description ? styles.errorInput : ""}
          />
          {errors.description && touched.description && (
            <div className={styles.fieldError}>{errors.description}</div>
          )}
        </div>

        <div className={styles.buttonGroup}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={styles.submitButton}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Follow-up"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateFollowUp;